<template>
  <div class="protokoll-preview">
    <Paginated :itemsPerPage="18" :fetch="fetchNextPage">
      <template #default="{ items, itemsTotal }">
	<strong style="line-height: 3.75rem">{{ itemsTotal }} {{$t('Pages')}}</strong>
	<ul class="protokoll-preview-list">
	  <li
	    v-for="item in items"
	    :key="item.number"
	    class="protokoll-preview-item"
	  >
	    <slot v-bind="item"></slot>
	  </li>
	</ul>
      </template>
    </Paginated>
  </div>
</template>

<style>
 .protokoll-preview {
   min-height: 240px;
 }

 .protokoll-preview-list {
   display: flex;
   flex-flow: row wrap;
   margin: 1.25rem 0;
   padding: 1.25rem 0 0 1.25rem;
   background-color: rgba(0, 0, 0, 0.025);
 }

 .protokoll-preview-item {
   margin: 0 1.25rem 0.75rem 0;
 }

 .protokoll-preview-loader {
   height: 100%;
   display: flex;
   justify-content: center;
   align-items: center;
 }
</style>

<script>
 import Paginated from '@/components/Paginated.vue'

 export default {
   components: { Paginated },
   props: {
     id: {
       type: Number,
       required: true
     }
   },
   data() {
     return {
       total: null,
       isReady: false
     }
   },
   methods: {
     async fetchNextPage({ offset, limit }) {
       const data = await this.api.fetchDocumentPages(this.id, { offset, limit })
       this.isReady = true
       return data
     }
   }
 }
</script>
